export default "__VITE_ASSET__DvKV3BGU__"